import { makePublishHelper, makeSubscribeHelper } from '../helpers-creators';

const schema = {};

export const eventOpened = makePublishHelper(
  'eventOpened',
  'wh.common.event.ui.header.deposit.opened',
  schema,
);

export const onEventOpened = makeSubscribeHelper(
  'onEventOpened',
  'wh.common.event.ui.header.deposit.opened',
  schema,
);
